var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import MediaContext from "./MediaContext";
import { EPlayerRole } from "cresus-common";
import useSessionContext from "../tools/useSessionContext";
import useAuth from "./useAuth";
import AudioVideoClient from "./AudioVideoClient";
import CamPlayerComponent from "../components/player_game_element_component/CamPlayerComponent";
import { MediaSettings } from "../components/MediaSettings";
import useMedia from "./useMedia";
import { useMonitoringContext } from "./MonitoringContextProvider";
function AudioComponent(props) {
    const consumer = props.participant.consumer;
    const [isMuted, setIsMuted] = useState(consumer.paused);
    const { audioVideoClient } = useMedia();
    const refMuted = useRef(null);
    const refAudio = useRef(null);
    console.log("CONSUMER", consumer);
    // useEffect(() => {
    //   let stream = new MediaStream();
    //   stream.addTrack(consumer.track);
    //   // TODO keeps this as it might be usful to get audio volume
    //   // const AudioContext = window.AudioContext;// || window.webkitAudioContext;
    //   // let myAudioCtx = new AudioContext();
    //   // let mySource = myAudioCtx.createMediaStreamSource(stream);
    //   // let gainNode = myAudioCtx.createGain();
    //   // gainNode.gain.value = 2;
    //   // mySource.connect(gainNode);
    //   // gainNode.connect(myAudioCtx.destination);
    //   refAudio.current!.srcObject = stream;
    //   refAudio
    //     .current!.play()
    //     .catch((error) => console.warn("audioElem.play() failed:%o", error));
    //   (window as any).hack = refAudio.current;
    //   console.log("audio component", consumer.track, consumer.track.enabled);
    // });
    useEffect(() => {
        let stream = new MediaStream();
        stream.addTrack(consumer.track);
        if (refAudio.current) {
            refAudio.current.srcObject = stream;
            refAudio.current
                .play()
                .catch((error) => console.warn("audioElem.play() failed:%o", error));
        }
        // (window as any).hack = refAudio.current;
        // console.log("audio component", consumer.track, consumer.track.enabled);
        // 👇 ADD THIS CLEANUP FUNCTION
        return () => {
            stream.getTracks().forEach((track) => track.stop());
            if (refAudio.current) {
                refAudio.current.srcObject = null;
            }
        };
    }, [consumer.track]); // ✅ NOW IT ONLY RUNS WHEN THE TRACK CHANGES
    // function onCLick() {
    //     audioVideoClient.muteParticipant(props.participant.peerId);
    // }
    return (_jsx(_Fragment, { children: _jsx("audio", { autoPlay: true, ref: refAudio, muted: false, controls: false }, consumer.id) }));
}
const AudioVideoComponent = (props) => {
    // const [consumers, setConsumers] = useState<IParticipantInfos[]>();
    // 👇 FIX 1: Initialize state so consumers survive React background updates
    const [consumers, setConsumers] = useState(() => {
        return Array.from(props.audioVideoClient._consumers.values()).map((c) => ({
            peerId: c.appData.peerId,
            consumer: c,
        }));
    });
    // const refTextPeerId = useRef<HTMLDivElement>(null);
    // async function getMyPeerId()
    // {
    //     const peerId = await props.audioVideoClient.peer.request("getPeerId");
    //     refTextPeerId.current!.innerText = peerId;
    // }
    console.log("RENDERING AudioVideoComponent", props.audioVideoClient._consumers.size);
    // useEffect(() => {
    //   props.audioVideoClient.onNewConsumer.push(
    //     (participant: IParticipantInfos) => {
    //       const consumer = participant;
    //       console.log("new consumer", consumer);
    //       if (consumer.consumer.kind === "video") {
    //         if (props.onVideoConsumer) props.onVideoConsumer(consumer.consumer);
    //         return; // We won't add it here, we'll add it in the video component
    //       }
    //       setConsumers((consumers) => {
    //         if (!consumers) {
    //           return [consumer];
    //         }
    //         return [...consumers, consumer];
    //       });
    //     }
    //   );
    //   props.audioVideoClient.onConsumerClosed.push((consumer: Consumer) => {
    //     console.log("delete consumer", consumer);
    //     setConsumers((consumers) => {
    //       if (!consumers) {
    //         return [];
    //       }
    //       return consumers.filter((c) => c.consumer.id !== consumer.id);
    //     });
    //   });
    //   return () => {
    //     // When unmount we kill all the consumers
    //     setConsumers([]);
    //     props.audioVideoClient.ResetConsumers();
    //   };
    // }, []);
    useEffect(() => {
        // 👇 FIX 1a: Name the callbacks so we can remove them later
        const handleNewConsumer = (participant) => {
            const consumer = participant;
            console.log("new consumer", consumer);
            if (consumer.consumer.kind === "video") {
                if (props.onVideoConsumer)
                    props.onVideoConsumer(consumer.consumer);
                return;
            }
            setConsumers((prevConsumers) => {
                if (!prevConsumers)
                    return [consumer];
                // 👇 FIX 1b: Defensive check to prevent duplicate audio elements!
                if (prevConsumers.some((c) => c.consumer.id === consumer.consumer.id)) {
                    return prevConsumers;
                }
                return [...prevConsumers, consumer];
            });
        };
        const handleConsumerClosed = (consumer) => {
            console.log("delete consumer", consumer);
            setConsumers((prevConsumers) => {
                if (!prevConsumers)
                    return [];
                return prevConsumers.filter((c) => c.consumer.id !== consumer.id);
            });
        };
        props.audioVideoClient.onNewConsumer.push(handleNewConsumer);
        props.audioVideoClient.onConsumerClosed.push(handleConsumerClosed);
        return () => {
            setConsumers([]);
            // 👇 FIX 1c: Splicing out the listeners prevents ghost audio channels on refresh
            const indexNew = props.audioVideoClient.onNewConsumer.indexOf(handleNewConsumer);
            if (indexNew !== -1)
                props.audioVideoClient.onNewConsumer.splice(indexNew, 1);
            const indexClosed = props.audioVideoClient.onConsumerClosed.indexOf(handleConsumerClosed);
            if (indexClosed !== -1)
                props.audioVideoClient.onConsumerClosed.splice(indexClosed, 1);
            // props.audioVideoClient.ResetConsumers();
        };
    }, [props.audioVideoClient]);
    console.log(props.audioVideoClient.peer);
    return (_jsx("div", Object.assign({ className: "flex flex-col", style: { gap: 10 } }, { children: consumers === null || consumers === void 0 ? void 0 : consumers.filter((consumer) => consumer.consumer.kind === "audio").map((consumer, i) => {
            //The Fail-Safe. Never render an audio component for our own ID!
            if (consumer.peerId === props.audioVideoClient.peerId) {
                return null;
            }
            return (_jsx(AudioComponent, { participant: consumer }, `audioConsumer${i}`));
        }) })));
};
function MediaComponent(props) {
    const { audioVideoClient } = useMedia();
    const [selectedMicro, setSelectedMicro] = useState("");
    const [selectedCamera, setSelectedCamera] = useState("");
    const [settingsVisibility, setSettingsVisibility] = useState(false);
    const [fakeState, setFakeState] = useState(false);
    function getDefaultDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            // 👇 FIX 1a: Ping getUserMedia briefly just to force the browser to unhide device labels
            try {
                const tempStream = yield navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: true,
                });
                tempStream.getTracks().forEach((track) => track.stop());
            }
            catch (e) {
                console.warn("User has not granted media permissions yet.");
            }
            const devices = yield navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter((el) => el.kind === "videoinput");
            const audioDevices = devices.filter((el) => el.kind === "audioinput");
            // 👇 FIX 1b: Try to find the OS 'default' device first, fallback to the first available
            const foundCamera = videoDevices.find((d) => d.deviceId === "default") || videoDevices[0];
            const foundMicro = audioDevices.find((d) => d.deviceId === "default") || audioDevices[0];
            if (foundCamera)
                setSelectedCamera(foundCamera.deviceId); // Store ID, not label
            if (foundMicro)
                setSelectedMicro(foundMicro.deviceId); // Store ID, not label
        });
    }
    useEffect(() => {
        props.onMount([settingsVisibility, setSettingsVisibility]);
        getDefaultDevices();
    }, []);
    // let muted = audioVideoClient._producer?.paused ? "muted" : "not muted";
    // function handleMute() {
    //   if (audioVideoClient._producer?.paused) audioVideoClient.unmuteMic();
    //   else audioVideoClient.muteMic();
    //   setFakeState(!fakeState);
    // }
    // async function onValidateChange(micro: string, camera: string) {
    //   console.log("changing cam & mic", camera, micro);
    //   setSelectedCamera(camera);
    //   setSelectedMicro(micro);
    //   setSettingsVisibility(false);
    //   let devices = await navigator.mediaDevices.enumerateDevices();
    //   let camDeviceId = devices.filter((el) => el.label === camera)[0].deviceId;
    //   let micDeviceId = devices.filter((el) => el.label === micro)[0].deviceId;
    //   audioVideoClient.changeWebcam(camDeviceId);
    //   audioVideoClient.changeMicrophone(micDeviceId);
    // }
    function onValidateChange(microInput, cameraInput) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("changing cam & mic", cameraInput, microInput);
            setSelectedCamera(cameraInput);
            setSelectedMicro(microInput);
            setSettingsVisibility(false);
            let devices = yield navigator.mediaDevices.enumerateDevices();
            // 👇 FIX 1c: Match by deviceId first (best practice), fallback to label just in case
            let camDevice = devices.find((el) => el.deviceId === cameraInput || el.label === cameraInput);
            let micDevice = devices.find((el) => el.deviceId === microInput || el.label === microInput);
            if (camDevice)
                audioVideoClient.changeWebcam(camDevice.deviceId);
            if (micDevice)
                audioVideoClient.changeMicrophone(micDevice.deviceId);
        });
    }
    return (_jsx("div", { children: settingsVisibility && (_jsx(MediaSettings, { selectedCamera: selectedCamera, selectedMicrophone: selectedMicro, onClickClose: () => setSettingsVisibility(false), onClickValidate: onValidateChange })) }));
}
const MediaContextProvider = (props) => {
    console.log("MediaContextProvider rendering");
    // DO NOT SET ANY STATE HERE, this would cause a re-render and a re-render would cause
    // a re-creation of the websocket without closing the previous one
    const { token, role } = useAuth();
    const { sessionId, websocketPeer } = useSessionContext();
    const refVideo = useRef(null);
    let settingsVisibility = null;
    let setSettingsVisibility = null;
    function onMediaComponentMount(data) {
        settingsVisibility = data[0];
        setSettingsVisibility = data[1];
    }
    let cameraIsVisible = false;
    let setCameraIsVisible = () => { };
    let cameraIsNotebookShown = false;
    let setCameraIsNotebookShown = () => { };
    let isChatShown = false;
    let setIsChatShown = () => { };
    function onCamPlayerComponentMount(visibleState, notebookState, chatState) {
        cameraIsVisible = visibleState.isVisible;
        setCameraIsVisible = visibleState.setIsVisible;
        cameraIsNotebookShown = notebookState.isNotebookShown;
        setCameraIsNotebookShown = notebookState.setIsNotebookShown;
        isChatShown = chatState.isChatShown;
        setIsChatShown = chatState.setIsChatShown;
    }
    const videoTag = role === EPlayerRole.ANIMATOR ? (_jsx("video", { autoPlay: true, ref: refVideo, muted: true, controls: false }, "videocomponent")) : (_jsx("video", { autoPlay: true, ref: refVideo, muted: false, controls: false, style: {
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            zIndex: 50,
        } }, "videocomponent"));
    const monitoringContext = useMonitoringContext();
    // 1. Start with no client while we wait for the network
    const [audioVideoClient, setAudioVideoClient] = useState(null);
    const videoHolderRef = useRef(null);
    const videoHolderHolderRef = useRef(null);
    // 2. The Role-Aware Bouncer & Kill-Switch
    useEffect(() => {
        // GUARD CLAUSE 1: Everyone needs a sessionId and a websocketPeer
        if (!sessionId || !websocketPeer) {
            console.log("⏳ Bouncer: Waiting for base Session data...");
            return;
        }
        // GUARD CLAUSE 2: Only Animators strictly need a token
        if (role === EPlayerRole.ANIMATOR && !token) {
            console.log("⏳ Bouncer: Waiting for Animator Auth Token...");
            return;
        }
        console.log("🟢 Bouncer passed! Creating WebRTC Client for session:", sessionId);
        // Create the client ONLY when the required data is present
        const client = new AudioVideoClient(sessionId, token || "", // Provide a fallback empty string for players so TypeScript is happy
        role, websocketPeer, monitoringContext);
        setAudioVideoClient(client);
        // KILL-SWITCH: Destroy this specific client if the session changes or component unmounts
        return () => {
            console.log(`🧹 Pulling the kill-switch for session ${sessionId}!`);
            client.destroy();
        };
    }, [token, sessionId, websocketPeer, role]);
    // 3. THE BYPASS: If they don't have a session, they are in the lobby/login.
    // Let the Router render the UI, but DO NOT provide the WebRTC context.
    // TODO : check for the need or if it does not break with the forgotten pasword page
    if (!sessionId || !websocketPeer) {
        console.log("No active session, bypassing MediaGatekeeper...");
        return _jsx(_Fragment, { children: props.children });
    }
    // 4. THE GATEKEEPER: They HAVE a session, but the client is still building.
    // Block the UI and show the loading screen.
    if (!audioVideoClient) {
        return (_jsx("div", Object.assign({ style: {
                display: "flex",
                height: "100vh",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#282828",
                color: "white",
            } }, { children: _jsx("h2", { children: "Connecting to Media Servers..." }) })));
    }
    const value = {
        audioVideoClient: audioVideoClient,
        // audioVideoClient: new AudioVideoClient(
        //   sessionId,
        //   token!,
        //   role,
        //   websocketPeer!,
        //   monitoringContext
        // ),
        videoComponent: videoTag,
        openMediaSettings: () => {
            setSettingsVisibility(true);
        },
        setCameraMode: (isVisible, isNotebookShown, isChatShown) => {
            console.log("setting camera mode", isVisible, isNotebookShown, isChatShown);
            setCameraIsVisible(isVisible);
            setIsChatShown(isChatShown);
            setCameraIsNotebookShown(isNotebookShown);
        },
        moveVideoTag: (parent) => {
            var _a;
            if (Boolean(parent))
                parent.appendChild(videoHolderRef.current);
            // Catch to handle the case where the video is not playing (local when not running webaudio server)
            // value.audioVideoClient.enableWebcam();
            (_a = refVideo.current) === null || _a === void 0 ? void 0 : _a.play().catch((error) => console.error("Cannot play video", error));
        },
        releaseVideoTag: () => {
            if (Boolean(videoHolderHolderRef === null || videoHolderHolderRef === void 0 ? void 0 : videoHolderHolderRef.current))
                videoHolderHolderRef === null || videoHolderHolderRef === void 0 ? void 0 : videoHolderHolderRef.current.appendChild(videoHolderRef.current);
        },
    };
    function onVideoConsumer(consumer) {
        console.log("received video consumer", consumer);
        let stream = new MediaStream();
        stream.addTrack(consumer.track);
        refVideo.current.srcObject = stream;
    }
    // useEffect(() => {
    //   value.audioVideoClient.unmuteMic();
    //   // value.audioVideoClient.muteMic();
    // }, []);
    const videoPhoneWrapper = (_jsx("div", Object.assign({ className: "h-full relative", style: {
            objectFit: "cover",
            maskPosition: "center 14cqw",
            maskImage: "url(./assets/UI/mask_cam_mask.png)",
            maskRepeat: "no-repeat",
            maskSize: "cover",
            borderRadius: 10,
            margin: 10,
            background: "#282828",
            zIndex: -1,
        } }, { children: value.videoComponent })));
    return (_jsxs(MediaContext.Provider, Object.assign({ value: value }, { children: [_jsx(MediaComponent, { onMount: onMediaComponentMount }), _jsx(AudioVideoComponent, { onVideoConsumer: onVideoConsumer, audioVideoClient: value.audioVideoClient }), _jsx("div", Object.assign({ style: { visibility: "hidden", height: 0 } }, { children: _jsx("div", Object.assign({ ref: videoHolderHolderRef }, { children: _jsx("div", Object.assign({ ref: videoHolderRef }, { children: value.videoComponent })) })) })), role !== EPlayerRole.ANIMATOR && (_jsx(CamPlayerComponent, { onComponentMount: onCamPlayerComponentMount, videoComponent: videoPhoneWrapper })), props.children] })));
};
export default MediaContextProvider;
